import ImagesLoaded from 'imagesloaded'

class ImgLoaded {
  constructor() {
    this.images = document.querySelectorAll('.c-image-load')
    this.init()
  }

  init() {
    this.done()
  }

  done() {
    const imgLoad = new ImagesLoaded(this.images)

    imgLoad.on('done', () => {
      this.images.forEach((element) => {
        element.classList.add('--loaded')
      })
    })
  }
}

export default ImgLoaded
